module.exports = __webpack_public_path__ + "c1273d4eb705bae8209ea9a6486ecdf4.pdf";